import {Link} from 'react-router-dom';
import React from 'react';

import {postApi} from '../../../utils/functions';
import EventEmitter from '../../../utils/emmiter';
import {UserContext} from '../../../utils/usercontext';
import Genres from '../genres/genres';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import './audiobox.css';

export default class AudioBox extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			audiodata: {},
			audioState: {
				id: parseInt(this.props.audio.id),
				currentTime: 0,
				duration: 0,
				buffered: 0,
				pause: true,
				replay: false,
				repeat: false,
				favorite: false,
				like: false,
			},
			AudioListener: null,
			AudioStatsListener: null,
    };
		this.audioPause = this.audioPause.bind(this);
		this.audioReplay = this.audioReplay.bind(this);
		this.audioRepeat = this.audioRepeat.bind(this);
		this.audioFavorite = this.audioFavorite.bind(this);
		this.audioLike = this.audioLike.bind(this);
		this.displayTime = this.displayTime.bind(this);
  };

  // Instantiate a Video.js player when the component mounts
  componentDidMount() {
    
		this.getAudioData();

		const AudioListener = EventEmitter.addListener('/audio/player', async (data) => {
			if( data.id === this.state.audioState.id ) {
				this.setState({audioState: data});
				if( data.favorite !== this.state.audioState.favorite || data.like !== this.state.audioState.like ) {
					var params = new URLSearchParams();
					params.append('id', data.id);
					params.append('favorite', data.favorite?1:0 );
					params.append('like', data.like?1:0 );
					await postApi('/api/v2/audio/stats', params);
				}
			}
		}); this.setState({AudioListener});

		const AudioStatsListener = EventEmitter.addListener('/audio/stats', (data) => {
			if( data.id === this.state.audiodata.id ) {
				let audiodata = this.state.audiodata;
				audiodata.plays = data.plays;
				audiodata.favorites = data.favorites;
				audiodata.likes = data.likes;
				this.setState({audiodata});
			}
		}); this.setState({AudioStatsListener});
  }

	async getAudioData() {
		try{
			var params = new URLSearchParams();
			params.append('id', this.state.audioState.id);
			params.append('waveform', 0);
			const x = await postApi('/api/v2/audio', params);
			let audioState = this.state.audioState;
			audioState.favorite = x.data.audio.favorite;
			audioState.like = x.data.audio.like;
			audioState.duration = x.data.audio.length;
			this.setState({audiodata: x.data.audio, audioState});
		}catch(error){console.log("Error");}
	}

  // Dispose the player when the component will unmount
  componentWillUnmount() {
		if( this.state.AudioListener) this.state.AudioListener.remove();
		if( this.state.AudioStatsListener) this.state.AudioStatsListener.remove();
	}

	componentDidCatch() {
		//throw new Error("An error has occured in a very Buggy component!");
	}


	audioPause(id) {
		if( window.location.href.replace('https://www.','https://') !== window.location.href ) {
			window.location.href = 'https://mix365.co.uk/' + this.state.audiodata.id + '/' + this.state.audiodata.shortname;
		} else {
			let audioState = this.state.audioState;
			if( audioState.id === 0 ) audioState.id = this.props.match.params.id;
			audioState.pause = !audioState.pause;
			EventEmitter.emit('/audio/player', audioState);
		}
	}
	audioReplay() {
		let audioState = {...this.state.audioState};
		audioState.replay = !audioState.replay;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioRepeat() {
		let audioState = {...this.state.audioState};
		audioState.repeat = !audioState.repeat;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioFavorite() {
		let audioState = {...this.state.audioState};
		audioState.favorite = !audioState.favorite;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioLike() {
		let audioState = {...this.state.audioState};
		audioState.like = !audioState.like;
		EventEmitter.emit('/audio/player', audioState);
	}
	audioDownload(id, size) {
		window.location.href="https://mix365.co.uk/audio/"+id+"/"+size;
	}

	displayTime(time) {
		try{
			var date = new Date(null);
			date.setSeconds(time); // specify value for SECONDS here
			var result = date.toISOString().substr(11, 8);
			return result;
		}catch(error){return "00:00:00";}
	}


  render() {
		const user = this.context;
    return (
			<>
				{Object.keys(this.state.audiodata).length>0&&
					<Col xs={12} className="px-1">
						<Row className="audiobox gx-0">
							<Col xs={12} className="audiobox-cover">
								<Link className="p-schedule-event-audio-link" to={`/${this.state.audiodata.id}/${this.state.audiodata.showname.replaceAll('  ',' ').replaceAll(' | ','-').replaceAll(' - ','-').replaceAll(' ','-').replaceAll('/','')}`}>
									<LazyLoadImage alt="Previous Set Cover" src={`https://mix365.co.uk/images/publish/${this.state.audiodata.filename.replace('.m4a','')}-0.png`} className="weeklydjs-avatar-img" />
								</Link>
								<div className="audiobox-play text-vcenter">
									<Link className="p-schedule-event-audio-link" to={`/${this.state.audiodata.id}/${this.state.audiodata.showname.replaceAll('  ',' ').replaceAll(' | ','-').replaceAll(' - ','-').replaceAll(' ','-').replaceAll('/','')}`}>
										<FontAwesomeIcon icon="play" />
									</Link>
								</div>
								{user.user.access?.mod_access &&
									<div className="audiobox-download" onClick={()=>this.audioDownload(this.state.audiodata.code, this.state.audiodata.size)}>
									
											<OverlayTrigger key="download" placement="top" overlay={
													<Tooltip id="tooltip-download">Download Audio Track</Tooltip>
												}><FontAwesomeIcon icon="file-arrow-down" />
											</OverlayTrigger>
											
									</div>
								}
								
							</Col>
							<Col xs={12} className="audiobox-profile">
								<Row className="audiobox-profile-bottom gx-0">
									<div className="audiobox-avatar text-center">
										<Link to={`/${this.state.audiodata.username.toLowerCase().replaceAll(' ','_')}`}>
											<LazyLoadImage alt="Profile Avatar" src={`https://mix365.co.uk/${this.state.audiodata?.avatar}`} className="audiobox-avatar-img" />
										</Link>
									</div>
									<Col className="">
										<Link className="p-schedule-event-audio-link" to={`/${this.state.audiodata.id}/${this.state.audiodata.showname.replaceAll('  ',' ').replaceAll(' | ','-').replaceAll(' - ','-').replaceAll(' ','-').replaceAll('/','')}`}>{this.state.audiodata.showname.length>0?this.state.audiodata.showname:'SHOWNAME'}</Link><br />
										<ul className="audiobox-stats">
											<li onClick={()=>this.audioPause(this.state.audioState.id)}>
												<OverlayTrigger key="plays" placement="top" overlay={
														<Tooltip id="tooltip-plays">{this.state.audiodata.plays} Plays</Tooltip>
													}><div><FontAwesomeIcon icon="play" /> {this.state.audiodata.plays}</div>
												</OverlayTrigger>
											</li>
											<li className="audio-cursor" onClick={this.audioFavorite}>
												<OverlayTrigger key="favorite" placement="top" overlay={
														<Tooltip id="tooltip-favorite">{user.user.user.rank===1?'Login to set Favorite':'Favorite'}</Tooltip>
													}><div><FontAwesomeIcon icon="heart" style={{color:user.user.user.rank>1?this.state.audioState.favorite?'#ff1493':'#444444':'#444444'}} /> {this.state.audiodata.favorites}</div>
												</OverlayTrigger>
											</li>
											<li className="audio-cursor" onClick={this.audioLike}>
												<OverlayTrigger key="thumbs-up" placement="top" overlay={
														<Tooltip id="tooltip-thumbs-up">{user.user.user.rank===1?'Login to set Like':'Like'}</Tooltip>
													}><div><FontAwesomeIcon icon="thumbs-up" style={{color:user.user.user.rank>1?this.state.audioState.like?'#00b9fb':'#444444':'#444444'}} /> {this.state.audiodata.likes}</div>
												</OverlayTrigger>
											</li>
										</ul>
									</Col>
									<Col xs={12} className="px-3">
										<Genres genres={this.state.audiodata.genres} />
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				}
			</>
    );
  }
}